import React, { useEffect , useState} from "react"
import { Container } from "react-bootstrap"
import HTMLReactParser from 'html-react-parser';
//import ScrollAnimation from "react-animate-on-scroll";
import axios from "axios";
import "./Counter.scss"

const SocialMedia = (props) => {
  let [reviewCount, setReviewCount] = React.useState(0);
  let [averageRating, setAverageRating] = React.useState(0);
  const [renderComponent, setRenderComponent] = useState(false);
    useEffect(()=>{
      let url = `${process.env.GATSBY_STRAPI_SRC}/google-review-reviews`
      window.addEventListener("mousemove", () => {
          if (renderComponent === false) {
              setRenderComponent(true)
          }
      })
      window.addEventListener("keypress", () => {
          if (renderComponent === false) {
              setRenderComponent(true)
          }
      })
      window.addEventListener("touchmove", () => {
          if (renderComponent === false) {
              setRenderComponent(true)
          }
      })

      if(renderComponent){
          getitems(url);
      }
    })
  const wordToNumber = { 'ONE': 1, 'TWO': 2, 'THREE': 3, 'FOUR': 4, 'FIVE': 5 };
  const strapiconfig = {
    headers: {
        Authorization:
            `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
    },
  }

  const getitems = async url => {
    try {
      const { data } = await axios.get(url,strapiconfig)// could be from env files 
      setReviewCount(data.length);
      let sumOfScores = 0;
      data.map((review) => {
        const reviewStringValue = review.starRating;
        sumOfScores += wordToNumber[reviewStringValue];
      })
      setAverageRating(Math.round(sumOfScores / data.length * 10) / 10);
    } catch (error) {
      // cache it if fail/error;
      console.error(error)
    }

  }
  return (
    <section className={`counter sec-pdy-120 ${props.page === 'Home' ? 'home-counter' : 'landing-counter'}`}>
      <Container>
          <div className="counter-wrapper social-media-list">
           <div className="row">
            {props.stats && props.stats.map((stat, i) => {
              return (
                <div className="col-6 col-xl-3">
                
                  <div animateIn='fadeInUp' delay={`${i}+100`} animateOnce className="total-block">
                    <a href={stat.URL} target="_blank">
                      <div className="total-record">
                        <div className="social-icons">
                        {stat.Icon == "Facebook" &&
                          <i className="icon-facebook" alt="facebook logo"></i>
                        }
                        {stat.Icon == "Instagram" &&
                          <i className="icon-instagram" alt="instagram logo"></i>
                        }
                        {stat.Icon == "LinkedIn" &&
                          <i className="icon-linkedin-logo" alt="linkedln logo"></i>
                        }
                        {stat.Icon == "Youtube" &&
                          <i className="icon-youtube-logo" alt="youtube logo"></i>
                        }
                      </div>
                        <div className="content text-sm">
                          <span className="total-count h3"> {stat.Value}</span>
                          {HTMLReactParser(stat?.Content.replace(/\n/g, '<br />'))}
                        </div>
                      </div>
                    </a>
                  </div>

                </div>
              )
            })}
          </div>

        </div>

      </Container>

    </section>
  )
};
export default SocialMedia